import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    currentAdminUser: null,
    active: false,
    currentClient: {},
    availableCategories: null
}
const mutations = {
  setAdminUser(state, user) {
    state.currentAdminUser = user
  },
  setActive(state, boo) {
    state.active = boo
  },
  setCurrentClient(state, currentClient) {
    state.currentClient = currentClient
  },
  setAvailableCategories(state, availableCategories) {
    state.availableCategories = availableCategories
  }
}
const actions = {
  login(state, email){
    firebase.firestore().collection('admin-users').doc(email).get()
    .then(doc => {
      if (!doc.exists) {
        console.log('No such user!')
      } else {
        let user = doc.data()
        store.commit('setAdminUser', user)
        store.commit('setActive', true)
      }
    })
    .catch(err => {
      console.log('Error getting document', err)
    })
  },
  logout(state){
    store.commit('setAdminUser', null)
    store.commit('setCurrentClient', null)
    store.commit('setActive', false)
  },
  setCurrentClient(state, currentClient){
    store.commit('setCurrentClient', currentClient)
  },
  setAvailableCategories(state){
    firebase.firestore().collection('content').doc('availableCategories').get()
    .then(doc => {
      if (!doc.exists) {
        console.log('No such document!')
      } else {
        let availableCategories = doc.data()
        console.log(availableCategories)
        store.commit('setAvailableCategories', availableCategories.categoriesList)
      }
    })
    .catch(err => {
      console.log('Error getting document', err)
    })
  }
}
const getters = {
    currentAdminUser: state => state.currentAdminUser,
    currentClient: state => state.currentClient,
    active: state => state.active,
    availableCategories: state => state.availableCategories
}
const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})
export default store;